import { useEffect, useRef, useState } from 'react'
import { AgeConfirmation, FilterOptions, PickupReturnInfo, PPlanningPage, UiModal, UiModalRight } from 'libs/raas-ui-react-components/src/components';
import PrivatePagesWrapper from 'components/PrivatePagesWrapper/PrivatePagesWrapper';
import { useNavigate } from 'react-router-dom';
import { apiUpdateUnder16Age, getDataTmbActivities, getNotificationsCall, getUsersUnder16Literals, mapPlanningObject } from './PlannerFlow.service';
import { ICardTmbActivities, INotifications, PlanningObject } from './PlannerFlow.model';
import { removeItemStorage, setItemStorage } from 'services/util/sessionStorage.service';
import { IUserData, RaaSSession, SessionStorageItems, removeTMBSummaryDetail, setIdTmbSelect, setStorage, setUserDetail } from 'services/user/user.session.service';
import { ITripSelectedDetails } from 'models/TripInterface';
import useSession from 'hooks/useSession';
import { getRealDataFav, needImperativeData } from 'services/util/addressesFav.service';
import useToast from 'hooks/useToast';
import { getFiltersOptionsTabs, getLiteralsCardBanner, PlannerBoxLiterals } from './PlannerFlow.aux';
import { useTranslation } from 'react-i18next';
import { getUserData } from 'services/user/user-micros.service';
import { mapPMyProfile } from 'pages/private/PrivateHome/PrivateHome.util';
import { mappingScreenNameAnalytics } from 'services/util/dataLayerAnalytics';
import { CHECKAGE, checkUnder16 } from 'services/util/util.service';
import { getLanguageTMB } from '../TmbDetailActivity/TmbDetailActivity.service';
import { getHomeSixt, getPickupReturnLiterals } from 'pages/private/SixtFlow/SixtFlow.utils';
import Map from '../Map/Map';
import { getMaptFilterLiterals } from './PlannerFlow.utils';
import { getBoundingBox } from '../Map/Map.service';
import { mappingStation } from '../Map/Map.utils';
import { IUserLocation } from '../Map/Map.model';
import MapContainer from '../MapRefactor/MapContainer';
import { getRouteApi } from '../MapRefactor/userServices';
declare const window: any;
export const PlannerFlow = () => {
    const navigate = useNavigate();
    const { setTripSelectedDetails, setReturnTripSelectedDetails, setCardTMB, setNextToMeData } = useSession();
    const { setSession, setLogged, setLoggedSocial, setUserConnected, userConnected, logged } = useSession();
    const [userDetailLocal, setUserDetailLocal] = useState(null);
    const [userData, setUserData] = useState<any>("");
    const { openToast } = useToast();
    const [t, i18n] = useTranslation("plannerFlow");
    const [tTmb] = useTranslation("tmbPages");
    const [t2] = useTranslation("sixtFlow")
    const [t3] = useTranslation("sixtModals");

    const [tGlobal] = useTranslation("global");
    const [confirmationAge, setConfirmationAge] = useState(false);
    const [isOver16, setIsOver16] = useState(false);
    const [showModalUnder16, setShowModalUnder16] = useState(false as boolean);
    const usersUnder16ModalLiterals = getUsersUnder16Literals(t);
    const [activitiesList, setActivitiesList] = useState<ICardTmbActivities>();

    const [showPickupReturnInfoModal, setShowPickupReturnInfoModal] = useState(false);
    const [pickupInfo, setPickupInfo] = useState(null as any);


    let lenguage = "";
    let raasUserDetail = JSON.stringify(sessionStorage.getItem('raas-user-detail')) || null
    const planingPageLiterals = { desc: t("planingPageLiterals.desc"), title: t("planingPageLiterals.title"), nextToMe: t("planingPageLiterals.nextToMe") }
    const literalsTmb = { titleBanner: tTmb("tmbPlanner.titleBanner"), tripDescription: tTmb("tmbPlanner.tripDescription"), seeMore: tTmb("tmbPlanner.seeMore"), }
    const addressFavCallStatus = useRef(false);
    const planingBoxLiterals = PlannerBoxLiterals(t) as any;
    const literalsCardBanner = getLiteralsCardBanner(t2) as any;

    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [filtersOptions, setFiltersOptions] = useState(getMaptFilterLiterals(t));

    const filtersOptionsTabs = getFiltersOptionsTabs(t) as any;



    const [userLocation, setUserLocation] = useState(null as any);
    const [dataMapping, setDataMapping] = useState([] as any);
    const [groupedLocations, setGroupedLocations] = useState(null as any)

    const [notificationsBanner, setNotificationsBanner] = useState({} as INotifications);



    useEffect(() => {
        !!sessionStorage?.getItem('current-page') && sessionStorage?.removeItem('current-page');
    }, [])

    useEffect(() => {
        if (logged != false) {
            getData();
        }

    }, [logged]);

    useEffect(() => {
        if (sessionStorage.getItem('raas-language') != lenguage) {
            setActivitiesList(undefined)
            lenguage = sessionStorage.getItem('raas-language') as any
            setUserData(mapPMyProfile(userDetailLocal as any, t));
            //getTmbActivities(getLanguageTMB(i18n.language));

            setFiltersOptions(getMaptFilterLiterals(t, filtersOptions))
               geyNotifications();
        }

    }, [t]);





    const getData = () => {

        getUserData((response: any) => {
            const userDataResponse = response?.data;
            setUserDetail(userDataResponse)
            setUserDetailLocal(userDataResponse)
            setUserData(mapPMyProfile(userDataResponse, t));
            setUserConnected(userDataResponse);
            if (addressFavCallStatus.current === false && raasUserDetail) {
                getFavoriteAddresses(userDataResponse);
            }
            checkForMinors(userDataResponse);
        }, () => {
            openToast("error", t("literals.error"), t("literals.errorTryAgainLater"));
            logoutClick();
        })
    };
    useEffect(() => {
        setTripSelectedDetails({} as ITripSelectedDetails);
        setReturnTripSelectedDetails({} as ITripSelectedDetails);
        removeItemStorage(SessionStorageItems.TRIP);
        removeItemStorage(SessionStorageItems.RAAS_TRIP_SUMMARY_DETAIL);
        removeItemStorage(SessionStorageItems.RAAS_RETURN_TRIP_SUMMARY_DETAIL);
        //getTmbActivities();
     
    }, []);


    const checkForMinors = (data: any) => {
        const checkId = checkUnder16(data);
        switch (checkId) {
            case CHECKAGE.askRequired:
                window.dataLayer?.push({
                    event: "page_view",
                    screen_name: 'legal_age_needed_alert',
                    screen_class: mappingScreenNameAnalytics(window.location.pathname),
                });
                setIsOver16(false);
                setConfirmationAge(true);
                break;
            case CHECKAGE.isUnderAge:
                setIsOver16(false);
                setConfirmationAge(true);
                break;
            case CHECKAGE.mandatoryAgeNeeded:
                setIsOver16(false);
                setConfirmationAge(true);
                break;
            // case CHECKAGE.mandatoryAgeNeededNoOver16:
            //     setIsOver16(false);
            //     setConfirmationAge(true);
            //     break;    
        }

    }

    const logoutClick = () => {
        setLogged(false);
        setLoggedSocial(false);
        setSession({} as RaaSSession);
        setUserConnected({} as IUserData);
        removeItemStorage(SessionStorageItems.RAAS_USER);
        removeItemStorage(SessionStorageItems.RAAS_USER_DETAIL);
        setStorage();
    }

    const getFavoriteAddresses = (data: any) => {
        if (logged && data.addresses.length > 0) {
            const addresses: Array<any> = data.addresses;
            const mustHaveImperativeData: boolean = needImperativeData(addresses);
            if (mustHaveImperativeData) {
                getRealDataFav(addresses,
                    (data: Array<any>) => {
                        setItemStorage('addresses-fav', data || []);
                        addressFavCallStatus.current = true;
                    },
                    () => {
                        //setItemStorage('addresses-fav', []);
                        addressFavCallStatus.current = true;
                    }
                );
            }
        }
    }

    const geyNotifications = () => {
        getNotificationsCall(
            (data: any) => {
                setNotificationsBanner(data.data.homeMessage)
            },
            () => {
                  setNotificationsBanner(null as any)
            }
        );
    }




    const toTripSelector = (e: any) => {
        const query = e.detail;

        const { ok, msg } = checkBookingDates(query, t);
        if (ok) {
            setPlanObject(query);
        } else {
            openToast("error", t("literals.error"), msg);
        }
    }

    const setPlanObject = (obj: any) => {
        const objMapped: PlanningObject = mapPlanningObject(obj);
        setItemStorage(SessionStorageItems.TRIP, objMapped);
        window.dataLayer?.push({
            event: "select_content",
            screen_name: 'home',
            screen_class: 'home',
            content_type: 'search',
            content_name: 'destination_search',
            journey_origin: 'home',
            journey_search: 'home'

        });
        navigate("/trip");
    }

    const okModalUnder16 = () => {
        window.dataLayer?.push({
            event: "select_content",
            screen_name: 'legal_age_needed_alert',
            screen_class: mappingScreenNameAnalytics(window.location.pathname),
            content_type: 'button',
            content_name: 'add_legal_age',
        });
        setShowModalUnder16(false);
        navigate("/personal-data?goTo=/plan");
    }
    /* AgeConfirmation Modal: confirmo que soy mayor de 16 años */
    const handleCloseModalClick = () => {
        // console.log('handleCloseModalClick');
        /* Cierro todas las modales */
        setIsOver16(false);
        setConfirmationAge(false);
        setShowModalUnder16(false);

        /* Actualizo la variable under16 a false */
        apiUpdateUnder16Age(false,
            (userData: any) => {
                checkForMinors(userData);
            },
            (err: any) => {
                console.warn('Algo ha ido mal: ', err);
            }
        )
    }
    /* AgeConfirmation Modal: soy menor de 16, boton "Entendido" */
    const handleUnderstoodClick = () => {
        setConfirmationAge(false);
        setShowModalUnder16(false);
        apiUpdateUnder16Age(true,
            () => {
                logoutClick();
                navigate('/');
            },
            (err: any) => {
                console.warn('Algo ha ido mal: ', err);
            }
        )
    }

    //Funcion que recoge la activida seleccionada
    const goSeeMoreTmb = (e: any) => {
        if ((e.detail.id !== "night-tour") && (e.detail.id !== "xmas-tour")) {
            //Variable de session para saber que imagen hay que cargar en el detalle
            window.sessionStorage.setItem('raas-id-tmb-image-select', e.detail.image);
            setIdTmbSelect(e.detail.id);
            removeTMBSummaryDetail();
            navigate("/detail-activy");
        } else {
            window.sessionStorage.setItem('raas-id-tmb-image-select', e.detail.image);
            setIdTmbSelect(e.detail.id);
            navigate("/tmb-night-bus-flow");
        }
    }

    const goSeeMoreSixt = (e: any) => {
        if (e.detail) {
            navigate("/sixt-flow")
        }
    }

    const getTmbActivities = (lenguage: any) => {

        getDataTmbActivities(logged,
            (response: any) => {
                setActivitiesList(response)
                setCardTMB(response)

            },
            (err: any) => {


            }, lenguage, window.sessionStorage["raas-trip-mock"])
    }

    const handleShowInfoChild = (data: any) => {
        setPickupInfo(data.detail)
        setShowPickupReturnInfoModal(true)

    };





    const handleShowFilter = () => {
        setShowFiltersModal(true)
    };
    const closeFilters = (e: any) => {
        setDataMapping([]);
        setGroupedLocations([]);

        const transport = e.detail.transport;
        const selectedItems = transport.filter((item: any) => item.selected);

        let result = '';

        if (selectedItems.length === transport.length) {
            result = 'ALL';
        } else if (selectedItems.length > 0) {
            // Unimos todos los backId seleccionados en un solo string separado por comas
            result = selectedItems
                .map((item: any) => item.backId)
                .join(',');
        } else {
            result = '';
        }
        setShowFiltersModal(false);
        callAPIMap(result, false);
    };



    // Define a function to calculate coordinates and set user location
    const calculateAndSetUserLocation = (latitude: number, longitude: number, offset = 11.25) => {
        const lowerLeftLatCoordinate = latitude - offset;
        const lowerLeftLongCoordinate = longitude - offset;
        const upperRightLatCoordinate = latitude + offset;
        const upperRightLongCoordinate = longitude + offset;

        setUserLocation({
            llLat: lowerLeftLatCoordinate,
            llLon: lowerLeftLongCoordinate,
            urLat: upperRightLatCoordinate,
            urLon: upperRightLongCoordinate,
            latitudeOrigen: latitude,
            longitudeOrigen: longitude,
        } as IUserLocation);
    };

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    calculateAndSetUserLocation(latitude, longitude);
                },
                () => {
                    // Default coordinates for failure case
                    const defaultLatitude = 40.4167047;
                    const defaultLongitude = -3.7035825;
                    calculateAndSetUserLocation(defaultLatitude, defaultLongitude);
                }
            );
        } else {
            console.error("La geolocalización no es compatible con este navegador.");
        }
    }, [navigator]);




    useEffect(() => {
        if (!userLocation) return;

        //callAPIMap('ALL', true);
    }, [userLocation]);


    const callAPIMap = (meta: string, removeLoading: boolean) => {
        getBoundingBox(
            userLocation,
            meta,
            (response: any) => {
                if (response === undefined) {
                    setDataMapping([]);
                    setGroupedLocations([])

                } else {
                    const { result, groupedLocations } = mappingStation(response, t)

                    setGroupedLocations(groupedLocations)
                    setDataMapping(result);


                }
            },
            (err: any) => { },
            window.sessionStorage["raas-trip-mock"],
            removeLoading
        );
    }


    return (
        <>
            <UiModal open={confirmationAge} blockOverlay={true}>
                <AgeConfirmation
                    literals={{
                        title: tGlobal("age-confirmation.title"),
                        description: tGlobal("age-confirmation.description"),
                        buttonText: tGlobal("age-confirmation.buttonText"),
                        confirmationButton: tGlobal("age-confirmation.confirmationButton"),
                        secondaryButtonText: tGlobal("age-confirmation.secondaryButtonText"),
                    }}
                    confirmation={isOver16}
                    onUnderstood={handleUnderstoodClick}
                    onCloseModal={handleCloseModalClick}
                />
            </UiModal>
            <UiModal blockOverlay={true} open={showPickupReturnInfoModal}>
                <PickupReturnInfo
                    literals={getPickupReturnLiterals(t3)}
                    pickupInfo={pickupInfo}
                    onCloseModal={() => setShowPickupReturnInfoModal(false)}
                />
            </UiModal>
            <UiModalRight blockOverlay={true} open={showFiltersModal}>
                <FilterOptions
                    onCloseModal={() => setShowFiltersModal(false)}
                    onSendFilter={(e) => closeFilters(e)}
                    options={JSON.stringify(filtersOptions)}
                    variant={'multi'}
                    tabs={filtersOptionsTabs}
                />
            </UiModalRight>
            <PPlanningPage
                show-tmb={true}
                literalsBanner={literalsTmb}
                activitiesList={activitiesList}
                literals={planingPageLiterals}
                literalsCardBanner={literalsCardBanner}
                literalsHomeSixt={getHomeSixt(t2)}
                boxliterals={planingBoxLiterals}
                onGoPlanningEvent={toTripSelector}
                onNavigateSeeMore={goSeeMoreTmb}
                onNavigateSixt={goSeeMoreSixt}
                //dataMapping={dataMapping}
                dataMapping={null}
                notificationsBanner={notificationsBanner}

            >
                {/* <div slot="map">
                    {userLocation && (
                        <MapContainer
                            latitude={userLocation.latitudeOrigen}
                            longitude={userLocation.longitudeOrigen}
                            dataMapping={dataMapping}
                            groupedLocations={groupedLocations}
                            onFilter={handleShowFilter}
                            onShowInfo={handleShowInfoChild}
                            getRouteApi={getRouteApi}
                            onDataPass={(e) => {
                                if (e.id) {
                                    setNextToMeData(e);
                                    navigate(`/sixt-flow`);
                                }
                            }}
                        />
                    )}

                </div> */}
            </PPlanningPage>
            <PrivatePagesWrapper></PrivatePagesWrapper>
        </>
    )
}



export const checkBookingDates = (details: PlanningObject, t?: any, inverse?: boolean) => {
    let ok = true;
    let msg = "";
    let { hours, minutes } = details?.departureSchedule?.value;
    let departureDate = new Date(details?.departureDate?.value);
    let departureFullDate = new Date(departureDate.getFullYear(), departureDate.getMonth(), departureDate.getDate(), parseInt(hours), parseInt(minutes));
    let actualDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), new Date().getHours(), new Date().getMinutes());
    if (!details.return) {
        ok = departureFullDate >= actualDate;
        if (!ok) msg = t("literals.previousDepartureDateCurrentDate");
    } else {
        hours = details?.arrivalSchedule?.value.hours;
        minutes = details?.arrivalSchedule?.value.minutes;
        let arrivalDate = new Date(details?.arrivalDate?.value);
        let arrivalFullDate = new Date(arrivalDate.getFullYear(), arrivalDate.getMonth(), arrivalDate.getDate(), parseInt(hours), parseInt(minutes));
        ok = (arrivalFullDate > departureFullDate) && (departureFullDate >= actualDate);
        if (!(arrivalFullDate > departureFullDate)) msg = t("literals.previousArrivalDateDepartureDate");
        if (inverse && (arrivalFullDate > departureFullDate)) msg = t("literals.previousArrivalDateDepartureDate");
        if (!(departureFullDate >= actualDate)) msg = t("literals.previousDepartureDateCurrentDate");
    }

    return { ok: inverse ? !ok : ok, msg };
}


